import { useState, useEffect } from 'react';
import { FetchUserEventData } from '../Utils/FetchUserEventData';

export const usePersonalEvents = (userid) => {
  const [personalEventsData, setPersonalEventsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        const data = await FetchUserEventData(userid);
        setPersonalEventsData(data);
        setError(null);
      } catch (err) {
        console.error("Error loading last month events:", err);
        setError(err);
        setPersonalEventsData(null);
      } finally {
        setLoading(false);
      }
    };
    loadEvents();
  }, [userid]);

  return { 
    personalEventsData, 
    loading, 
    error,
    personalEvents: personalEventsData?.events || []
  }
};
